import { useTranslation } from "react-i18next";
import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useEffect, useState } from "react";
import { useInfiniteQuery } from "react-query";
import { axiosInstance } from "api/axios";
import Search from "assets/icons/search.gif";
import {
  EOrder,
  ETypeOfOrder,
  IOrderObject,
} from "components/SortOrder/typings";
import Loading from "components/Loading";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import moment from "moment";
import { IBaeRequest } from "dto/Admin/IBaeRequest";
import { plGridLocales } from "utils/muiGridLocales";
import CustomToolbar from "components/CaseDossier/Toolbar";
import { EDeliveryRequestStatus } from "dto/EDelivery/EDeliveryRequestStatus";

const BaeRegister: FC<Props> = ({ searchText }) => {
  const { t } = useTranslation();
  const [requests, setRequests] = useState<IBaeRequest[]>([]);

  const [listFilter] = useState<IOrderObject>({
    type: ETypeOfOrder.LAST_SEEN,
    order: EOrder.DESCENDING,
  });

  const [nextPage, setNextPage] = useState(0);

  const {
    data,
    refetch,
    fetchNextPage,
    isLoading,
    status,
  } = useInfiniteQuery(
    ["baeRequests", listFilter, searchText],
    async () => {
      const query = new URLSearchParams(window.location.search);

      if (searchText.length) {
        query.append("Text", searchText);
      }

      // if (userId) {
      //   query.append("PageForId", userId);
      // }

      query.append("Page", nextPage.toString());
      query.append("SortProp", listFilter.type);
      query.append("SortOrder", listFilter.order);

      const res = await axiosInstance.get(`/admin/baeRequests?${query}`);
      // return res.data;
      return {
        items: res.data,
        LastPage: res.data.LastPage,
        nextPage: nextPage + 1,
      };
    },
    {
      staleTime: 0,
      cacheTime: 0,
      enabled: false,
      getNextPageParam: (lastPage) => {
        if (!lastPage.LastPage) {
          return nextPage + 1;
        }
        return undefined;
      },
    }
  );

  const compileData = async () => {
    if (!data) return;
    setNextPage(data.pages[data.pages.length - 1].nextPage);
    const users = await Promise.all(
      data?.pages
        .map((page) => {
          return page.items.Items;
        })
        .flat()

      // .sort((left: IPackage, right: IPackage) => {
      //   //@ts-ignore
      //   return right.Unread - left.Unread;
      // })
    );

    setRequests(users);
  };

  useEffect(() => {
    compileData();
  }, [data]);

  useEffect(() => {
    if (!listFilter.initalized) return;

    setNextPage(0);
    setRequests([]);
    setTimeout(() => {
      refetch();
    }, 100);
  }, [listFilter]);

  useEffect(() => {
    refetch();
  }, []);
  return (
    <div className={styles.wrapper}>
      <div className={styles.order}>
        {/* <SortOrder
          isLoading={false}
          refetch={() => {
            // setNextPage(0);
            // setClients([]);
            // setTimeout(() => {
            //   refetch();
            // }, 100);
          }}
          setListFilter={setListFilter}
          type={listFilter.type}
          order={listFilter.order}
        /> */}
      </div>

      <div className={styles.list}>
        {!requests.length && !isLoading && status !== "idle" && (
          <div className={styles.wrapper}>
            <div className={styles.empty}>
              <img src={Search} />
              <div>{t("emptyStates.noResults")}</div>
            </div>
          </div>
        )}

        {isLoading && <Loading />}
        {!isLoading && (
          <DataGridPremium
            sx={{
              border: 0,
              "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
                outline: "none !important",
              },
              "& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus":
                {
                  outline: "none !important",
                },
            }}
            localeText={plGridLocales}
            slots={{ toolbar: CustomToolbar }}
            showToolbar
            slotProps={{
              loadingOverlay: {
                variant: "skeleton",
                noRowsVariant: "skeleton",
              },
            }}
            columnHeaderHeight={30}
            onRowsScrollEnd={() => {
              fetchNextPage();
            }}
            onRowClick={() => {
              // const user = a.row as IUser;
              // navigate(`/admin/users/${user.Id}`);
            }}
            columns={[
              {
                field: "CreationDate",
                width: 140,
                headerName: t("columns.creationDate"),
                valueFormatter: (v) => {
                  if (v) {
                    return moment(v).format("DD.MM.yyyy HH:mm");
                  }
                  return null;
                },
              },
              {
                field: "Label",
                width: 180,
                headerName: t("columns.entity"),
                cellClassName: `${styles.nameCell}`,
              },
              {
                field: "UserLabel",
                width: 160,
                headerName: t("columns.requester"),
                cellClassName: `${styles.nameCell}`,
              },

              {
                field: "EDeliveryAddress",
                width: 120,
                headerName: t("columns.ade"),
              },

              {
                field: "Context",
                width: 120,
                headerName: t("columns.context"),
              },

              {
                field: "LegalFrom",
                width: 120,
                headerName: t("columns.legalForm"),
              },

              {
                field: "Status",
                width: 120,
                headerName: t("columns.status"),
                valueGetter: (value, row) => {
                  switch (row.Status) {
                    case EDeliveryRequestStatus.PENDING:
                      return t("statuses.pending");
                    case EDeliveryRequestStatus.PROCESSING:
                      return t("statuses.processing");
                    case EDeliveryRequestStatus.ERROR:
                      return t("errors.generic");
                    case EDeliveryRequestStatus.SUCCESS:
                      return t("statuses.success");
                  }
                },
              },
            ]}
            hideFooter={true}
            getRowId={(r) => r.RequestId}
            rows={requests}
          />
        )}
      </div>
    </div>
  );
};

export default BaeRegister;
